import * as React from 'react';
import { LocalizeContextProps, withLocalize } from 'react-localize-redux';
import { connect } from 'react-redux';
import { RouteComponentProps, withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { Dispatch } from 'redux';
import { organizationName } from '../../../stores/auth/selectors';
import { RootState } from '../../../stores/store';
import BottomNav from './BottomNav';
import PageNav from './PageNav';
import Toggler from './Toggler';
import UserIndicator from './UserIndicator';

import './Sidebar.scss';

interface Props extends LocalizeContextProps, RouteComponentProps {
orgName?: string;
}

class Sidebar extends React.Component<Props> {
    public render() {
        const t = this.props.translate;
        return (
            <div className="side-menu slide-in">
                <nav className="navbar navbar-default" role="navigation">
                    <div className="navbar-header">
                        <div className="brand-wrapper">
                            <Toggler />

                            <div className="brand-name-wrapper">
                                <Link to="#" className="navbar-brand">
                                    {this.props.orgName ?? 'AAS'}
                                    <small
                                        style={{
                                            color: '#aaa',
                                            fontSize: '60%',
                                        }}
                                    >
                                        {process.env.REACT_APP_VERSION ?
                                            'v' + process.env.REACT_APP_VERSION : ''}
                                    </small>
                                </Link>
                            </div>
                        </div>

                    </div>

                    <div className="side-menu-container">
                        <ul className="nav navbar-nav slide-in">
                            <UserIndicator />
                            <PageNav />
                            <BottomNav />
                        </ul>
                    </div>
                </nav>
            </div>
        );
    }
}

const mapStateToProps = (state: RootState) => ({
    orgName: organizationName(state),
});

const mapDispatchToProps = (dispatch: Dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(withLocalize(withRouter(Sidebar)));